/**
 * 地図の表示フィルタ。
 * 旧地図配車 (V3Plans presenters/ActionsOnMapPresenter.tsx / Presenter.tsx:685) と
 * 同じ 3 種を複数選択する。ラベルがそのまま保存値なので、文言を変えると
 * 既存ユーザーの保存値が読めなくなる点に注意。
 */
export const DISPLAY_KIND_OPTIONS = ['積地', '納品地', '車庫'] as const;

export type DisplayKind = typeof DISPLAY_KIND_OPTIONS[number];

const KNOWN = new Set<string>(DISPLAY_KIND_OPTIONS);

export const showsLoading = (kinds: readonly string[]): boolean => kinds.includes('積地');
export const showsUnloading = (kinds: readonly string[]): boolean => kinds.includes('納品地');
export const showsGarage = (kinds: readonly string[]): boolean => kinds.includes('車庫');

/**
 * localStorage 復元時のバリデータ（usePersistedJSON 用）。
 * 空配列は「全部外した」という意思なので通す（既定へ戻さない）。
 */
export function isDisplayKindArray(parsed: unknown): parsed is DisplayKind[] {
  // KNOWN は文字列の Set なので、has() が型チェックも兼ねる
  return Array.isArray(parsed) && parsed.every((k) => KNOWN.has(k as string));
}
